module.exports = __webpack_public_path__ + "static/media/farm-map-bg (with last icon).d19b1dbc.png";